import { setBaika, setExcelValidation, setTenDiscount, setThirtyDiscount } from '../../redux/actions/modal';
import { getDeviationRates, getSellingPrices } from './formula';
import { setToastsError } from '../../redux/actions/common';
import {
    formatToYYYYMMDD,
    formattedDate,
    getRelativeDate,
    getSameDayOfNextMonth,
    isPastDate,
    isStartAfterEnd,
    isWeekendSaleDay,
} from './date';
import { ChangeRequestCompetitorCreateRequest } from '../../services';
import iconv from 'iconv-lite';

const SALE_TYPE_END_DATE_LIMIT_DAYS = {
    [ChangeRequestCompetitorCreateRequest.saleType.DAILY]: 1,
    [ChangeRequestCompetitorCreateRequest.saleType.WEEKLY]: 7, // 週間特売
    [ChangeRequestCompetitorCreateRequest.saleType.WEEKEND]: 3,
    // [ChangeRequestCompetitorCreateRequest.saleType.MONTHLY]: null, // 未使用
    [ChangeRequestCompetitorCreateRequest.saleType.OTHER]: 14,
};

export const validateSearchInput = (dispatch, formData, t) => {
    if (!(formData.itemName || formData.jan || formData.selectedLine)) {
        dispatch(setToastsError('商品名かJANかライン名を入力してください。'));
        return true;
    }
    // JANに数字以外が含まれていないか確認
    if (isInvalidJan(formData.jan)) {
        dispatch(setToastsError(t('message.error.jan')));
        return true;
    }
    return false;
};

export const validateRegisterInput = (dispatch, formData, isHead, isCompetitor) => {
    const competitorStoreCodeValid = formData.competitorStoreCode !== '';
    const requesterNameValid = formData.requesterName.trim() !== '';
    const sourceValid = formData.source !== '';
    const registrationMethodValid = formData.registrationMethod !== '';

    // 左上からZ順でバリデーションチェックを実施
    if (isHead) {
        if (!competitorStoreCodeValid) {
            dispatch(setToastsError('競合チェーンが選択されていません。'));
            return true;
        }
    } else if (isCompetitor) {
        if (!competitorStoreCodeValid) {
            dispatch(setToastsError('調査実施店舗が選択されていません。'));
            return true;
        }
    }
    if (!requesterNameValid) {
        dispatch(setToastsError('入力者を入力してください。'));
        return true;
    } else if (!isCP932Encodable(formData.requesterName)) {
        dispatch(setToastsError('入力者に使用できない文字が含まれています。'));
        return true;
    }
    if (isCompetitor) {
        if (!sourceValid) {
            dispatch(setToastsError('情報取得元が選択されていません。'));
            return true;
        }
        if (!registrationMethodValid) {
            dispatch(setToastsError('登録方法が選択されていません。'));
            return true;
        }
    }
    return false;
};

export const validateFormInput = (dispatch, formData, isFreshness, isInstruction) => {
    if (!formData.discountedRequestSellingPrice && formData.discountedRequestSellingPrice !== 0) {
        dispatch(setToastsError('売価を入力してください。'));
        return true;
    }
    if (formData.discountedRequestSellingPrice < 1) {
        dispatch(
            setBaika({
                isShow: true,
                items: [formData],
            }),
        );
        return true;
    }
    if (!formData.salesStartDate) {
        dispatch(setToastsError('開始日を選択してください。'));
        return true;
    }
    if (formatToYYYYMMDD(formData.salesStartDate) !== formData.salesStartDate) {
        dispatch(setToastsError('開始日は「yyyy/mm/dd」の形式で入力してください。'));
        return true;
    }
    if (isPastDate(formData.salesStartDate)) {
        dispatch(setToastsError('開始日は本日以降の日付を選択してください。'));
        return true;
    }
    if (isInstruction && formData.saleType !== ChangeRequestCompetitorCreateRequest.saleType.WEEKEND) {
        if (formData.salesStartDate > formattedDate(getRelativeDate(new Date(), 1))) {
            dispatch(setToastsError('開始日は翌日までの日付を入力してください。'));
            return true;
        }
    } else if (isOverEndOfNextMonth(formData.salesStartDate)) {
        dispatch(setToastsError('開始日は翌月末までの日付を入力してください。'));
        return true;
    }
    if (formData.saleType === ChangeRequestCompetitorCreateRequest.saleType.WEEKEND && !isWeekendSaleDay(formData.salesStartDate)) {
        dispatch(setToastsError('開始日は金・土・日の日付を入力してください。'));
        return true;
    }
    if (!formData.salesEndDate) {
        dispatch(setToastsError('終了日を選択してください。'));
        return true;
    }
    if (formatToYYYYMMDD(formData.salesEndDate) !== formData.salesEndDate) {
        dispatch(setToastsError('終了日は「yyyy/mm/dd」の形式で入力してください。'));
        return true;
    }
    if (formData.salesStartDate > formData.salesEndDate) {
        dispatch(setToastsError('終了日は開始日以降を選択してください。'));
        return true;
    }
    if (isFreshness) {
        if (isOverEndOfNextMonth(formData.salesEndDate)) {
            dispatch(setToastsError('終了日は翌月末までの日付を入力してください。'));
            return true;
        }
        if (getDiffDays(formData) > 7) {
            dispatch(setToastsError('終了日は「開始日から7日以内」の日付を入力してください。'));
            return true;
        }
    } else {
        if (formData.saleType === ChangeRequestCompetitorCreateRequest.saleType.WEEKEND) {
            if (isOverEndOfNextMonth(formData.salesEndDate)) {
                dispatch(setToastsError('終了日は翌月末までの日付を入力してください。'));
                return true;
            }
            if (getDiffDays(formData) > SALE_TYPE_END_DATE_LIMIT_DAYS[formData.saleType] || !isWeekendSaleDay(formData.salesEndDate)) {
                dispatch(setToastsError('終了日は開始日と同じ週末（金・土・日）の日付を入力してください。'));
                return true;
            }
        } else if (formData.saleType === ChangeRequestCompetitorCreateRequest.saleType.MONTHLY) {
            if (new Date(formData.salesEndDate) > getSameDayOfNextMonth(formData.salesStartDate)) {
                dispatch(setToastsError('終了日を開始日の翌月同日以前になるように設定してください。'));
                return true;
            }
        } else {
            if (isOverEndOfNextMonth(formData.salesEndDate)) {
                dispatch(setToastsError('終了日は翌月末までの日付を入力してください。'));
                return true;
            }
            if (getDiffDays(formData) > SALE_TYPE_END_DATE_LIMIT_DAYS[formData.saleType]) {
                dispatch(
                    setToastsError(
                        `終了日は「開始日から${SALE_TYPE_END_DATE_LIMIT_DAYS[formData.saleType]}日以内」の日付を入力してください。`,
                    ),
                );
                return true;
            }
        }
    }
    if (isFreshness) {
        if (!formData.freshnessReason) {
            dispatch(setToastsError('鮮度起因値下げ理由を入力してください。'));
            return true;
        }
    }
    if (formData.otherSpecialReports && !isCP932Encodable(formData.otherSpecialReports)) {
        dispatch(setToastsError('その他特記事項に使用できない文字が含まれています。'));
        return true;
    }
    return false;
};

export const validateExcelInput = (dispatch, formData) => {
    const errors = [];
    formData.forEach((row) => {
        if (!row.expandSalesFloor) {
            errors.push({
                rowNumber: row.id,
                message: '売場展開を選択してください。',
            });
        }
        if (!row.discountedRequestSellingPrice) {
            errors.push({
                rowNumber: row.id,
                message: '売価を入力してください。',
            });
        }
        if (isNaN(Number(row.discountedRequestSellingPrice))) {
            errors.push({
                rowNumber: row.id,
                message: '売価に不正な文字列が入力されています。',
            });
        }
        if (row.discountedRequestSellingPrice < 1) {
            errors.push({
                rowNumber: row.id,
                message: '売価は1以上の数値を入力してください。',
            });
        }
        if (!row.packingCategory) {
            errors.push({
                rowNumber: row.id,
                message: '販売方法・荷姿を選択してください。',
            });
        }
        if (!row.saleType) {
            errors.push({
                rowNumber: row.id,
                message: '特売種別・期間を選択してください。',
            });
        }
        if (!row.salesStartDate) {
            errors.push({
                rowNumber: row.id,
                message: '開始日を選択してください。',
            });
        }
        if (isOverEndOfNextMonth(row.salesStartDate)) {
            errors.push({
                rowNumber: row.id,
                message: '開始日は翌月末までの日付を入力してください。',
            });
        }
        if (!row.salesEndDate) {
            errors.push({
                rowNumber: row.id,
                message: '終了日を選択してください。',
            });
        }
        if (row.saleType === ChangeRequestCompetitorCreateRequest.saleType.MONTHLY) {
            if (row.salesStartDate && row.salesEndDate && new Date(row.salesEndDate) > getSameDayOfNextMonth(row.salesStartDate)) {
                errors.push({
                    rowNumber: row.id,
                    message: '終了日を開始日の翌月同日以前になるように設定してください。',
                });
            }
        } else if (isOverEndOfNextMonth(row.salesEndDate)) {
            errors.push({
                rowNumber: row.id,
                message: '終了日は翌月末までの日付を入力してください。',
            });
        }
        if (row.salesStartDate && row.salesEndDate) {
            if (isStartAfterEnd(row.salesStartDate, row.salesEndDate)) {
                errors.push({
                    rowNumber: row.id,
                    message: '終了日は開始日以降を選択してください。',
                });
            }
            if (getDiffDays(row) > 31) {
                errors.push({
                    rowNumber: row.id,
                    message: '終了日は「開始日から31日以内」の日付を入力してください。',
                });
            }
        }
        if (row.otherSpecialReports && !isCP932Encodable(row.otherSpecialReports)) {
            errors.push({
                rowNumber: row.id,
                message: 'その他特記事項に使用できない文字が含まれています。',
            });
        }
    });

    if (errors.length > 0) {
        dispatch(
            setExcelValidation({
                isShow: true,
                items: errors,
            }),
        );
        return true;
    }

    return false;
};

export const getDiffDays = (formData) => {
    const startDate = new Date(formData.salesStartDate);
    const endDate = new Date(formData.salesEndDate);
    const diff = endDate.getTime() - startDate.getTime();
    return diff / (1000 * 60 * 60 * 24);
};

/**
 * 翌月末までかどうかを判定する
 *
 * @param {string} date 判定する日付（yyyy/MM/dd）
 * @returns {boolean} 今日基準の翌月末より後の場合のみ true（日付が未入力・不正の場合は false）
 */
const isOverEndOfNextMonth = (date) => {
    if (!date) return false;

    // 入力日
    const inputDate = new Date(date);
    if (Number.isNaN(inputDate.getTime())) return false;
    inputDate.setHours(0, 0, 0, 0);

    // 基準日
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 翌々月の1日
    const firstDayOfMonthAfterNext = new Date(today.getFullYear(), today.getMonth() + 2, 1);
    firstDayOfMonthAfterNext.setHours(0, 0, 0, 0);

    // 翌々月初日を上限
    return inputDate >= firstDayOfMonthAfterNext;
};

export const discountValidation = async (dispatch, items, isFreshness, hasSellingPrices = false) => {
    try {
        // hasSellingPrices=true の場合、items には getSellingPrices の戻り値を渡すこと(同一APIの再呼び出しを省略するため)
        const itemsWithSellingPrice = hasSellingPrices ? items : await getSellingPrices(dispatch, items);

        const itemsWithDeviationRate = await getDeviationRates(dispatch, itemsWithSellingPrice);

        const thirtyDiscountItems = itemsWithDeviationRate.filter((item) => item.deviationRate >= 30);
        const tenDiscountItems = itemsWithDeviationRate.filter((item) => item.deviationRate >= 10);
        // 乖離判定（30%, 10%）
        if (thirtyDiscountItems.length > 0) {
            dispatch(
                setThirtyDiscount({
                    isShow: true,
                    items: thirtyDiscountItems,
                }),
            );
            return true;
        } else if (!isFreshness && tenDiscountItems.length > 0) {
            dispatch(
                setTenDiscount({
                    isShow: true,
                    items: tenDiscountItems,
                }),
            );
            return true;
        }
    } catch (error) {
        return false;
    }
    return false;
};

/**
 * 競合店変更・削除依頼ダイアログのバリデーション
 *
 * @param {Dispatch} dispatch
 * @param {object} formData フォームデータ
 * @return {boolean} 成功：false、失敗：true
 */
export const validateModalRequestApplyCompetitorStore = (dispatch, formData) => {
    // 「依頼理由」が「店名変更」の場合
    if (formData.requestReasonType === 'RENAME') {
        // 「変更後店名」が必須
        if (!formData.newStoreName.trim().length) {
            dispatch(setToastsError('変更後店名を入力してください。'));
            return true;
        }
    }
    // 「依頼理由」が「その他」の場合
    else if (formData.requestReasonType === 'OTHER') {
        // 「その他入力欄」が必須
        if (!formData.requestReasonOther.trim().length) {
            dispatch(setToastsError('その他入力欄を入力してください。'));
            return true;
        }
    }

    // 反映希望日
    if (formData.preferredDate === null) {
        dispatch(setToastsError('反映希望日を選択してください。'));
        return true;
    } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (new Date(formData.preferredDate) < today) {
            dispatch(setToastsError('反映希望日は今日以降の日付を選択してください。'));
            return true;
        }
    }

    return false;
};

/**
 * janが数字で入力されているかチェックする
 * - 数字（半角・全角）・スペース(半角・全角)・未入力は許容
 *
 * @param {*} jan
 * @returns {boolean} エラーの場合true
 */
export const isInvalidJan = (jan) => {
    if (!jan) return false;

    const normalizedJan = jan
        .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0))
        .replace(/　/g, ' ')
        .trim();

    return !/^\d+( +\d+)*$/.test(normalizedJan);
};

/**
 * CP932に変換可能か判定
 *
 * @param {string} input
 * @returns {boolean}
 */
export const isCP932Encodable = (input) => {
    if (!input) return true;

    try {
        const encoded = iconv.encode(input, 'CP932');
        const decoded = iconv.decode(encoded, 'CP932');

        return decoded === input;
    } catch {
        return false;
    }
};
